export const normalizeReviewStatus = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_");

const DELIVERED_REVIEW_STATUSES = new Set([
  "delivered",
  "completed",
  "delivery_completed",
  "shipment_delivered",
]);

export const isDeliveredReviewStatus = (value = "") =>
  DELIVERED_REVIEW_STATUSES.has(normalizeReviewStatus(value));

export const isDeliveredReviewEligible = (entity = {}) => {
  const statuses = [
    entity?.delivery_status,
    entity?.shipment_status,
    entity?.status,
    entity?.order_status,
    entity?.item_status,
    entity?.seller_fulfillment_status,
    entity?.shipment?.status,
    entity?.shipment?.shipment_status,
    entity?.tracking_summary?.status,
  ];

  return Boolean(entity?.delivered_at) || statuses.some(isDeliveredReviewStatus);
};

export const resolveReviewDisplayState = ({
  item = {},
  order = {},
  reviewOverride = null,
}) => {
  const reviewSubmitted =
    reviewOverride?.review_submitted ?? Boolean(item?.review_submitted);
  const mergedReviewContext = {
    ...order,
    ...item,
    delivered_at: item?.delivered_at || order?.delivered_at || null,
    delivery_status: item?.delivery_status || order?.delivery_status || null,
    order_status: item?.order_status || order?.order_status || null,
    status: item?.status || order?.status || null,
    shipment_status:
      item?.shipment_status ||
      order?.shipment_status ||
      order?.latest_shipment?.shipment_status ||
      order?.tracking_summary?.status ||
      null,
    shipment:
      item?.shipment || order?.shipment || order?.latest_shipment || null,
    tracking_summary:
      item?.tracking_summary || order?.tracking_summary || null,
  };
  const delivered = isDeliveredReviewEligible(mergedReviewContext);
  const canReview =
    reviewOverride?.can_review ??
    (item?.can_review !== undefined
      ? Boolean(item.can_review)
      : delivered && !reviewSubmitted);

  return {
    delivered,
    canReview,
    reviewSubmitted,
  };
};
